/**
 * Copyright (C) Sitevision 2002-2023, all rights reserved
 */
import { hasPortlet } from '../util/findPortlets';

if (hasPortlet('sv-youtube-portlet')) {
  import(/*webpackChunkName: "youtube-portlet" */ './plugins-slim');
}
